import React, { useContext, useEffect, useState } from 'react'
import LoginContext from '../../context'
import PaginationButtons from '../PaginationButtons'

const CashTableComponent = ({deposits, currentPage, totalPages, handlePageChange}) => {
 
  return (
    <>
      <table width="100%" border="0" cellspacing="0" cellpadding="0" className="border-b-none border-collapse bg-charcoal text-white text-xs font-Time">
        <thead>
          <tr>
            <th className="text-white border p-2.5 border-slate border-r bg-graphite">번호</th>
            <th className="text-white border p-2.5 border-slate border-r bg-graphite">신청날짜</th>
            <th className="text-white border p-2.5 border-slate border-r bg-graphite">충전금액</th>
            <th className="text-white border p-2.5 border-slate border-r bg-graphite">입금자명</th>
            <th className="text-white border p-2.5 border-slate border-r bg-graphite">처리일</th>
            <th className="text-white border p-2.5 border-slate border-r bg-graphite">충전/환급 포인트	</th>
            <th className="text-white border p-2.5 border-slate border-r bg-graphite">대기</th>
          </tr>
        </thead>
        <tbody>
          {deposits?.map((item, index) => (
            <tr key={item.id} className="text-center border-b border-slate">
              <td className="border p-2.5 border-slate">{(currentPage - 1) * 15 + index + 1}</td>
              <td className="border p-2.5 border-slate">{new Date(item.created_at).toLocaleString()}</td>
              <td className="border p-2.5 border-slate">{Number(item.amount).toLocaleString()}원</td>
              <td className="border p-2.5 border-slate">{item.depositor_name}</td>
              <td className="border p-2.5 border-slate">{new Date(item.created_at).toLocaleString()}</td>
              <td className="border p-2.5 border-slate">{item.points_awarded || ''}</td>
              <td className="border p-2.5 border-slate">{item.status_display || ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <PaginationButtons totalPages={totalPages} currentPage={currentPage} onPageChange={handlePageChange} />
    </>
  )
}

export default CashTableComponent